<h1 id="title" class="title">Mot de passe oublié</h1>

@if (showMessages.error && errors.length && !submitted) {
  <nb-alert outline="danger" role="alert">
    <p class="alert-title"><b></b></p>
    <ul class="alert-message-list">
      @for (error of errors; track error) {
        <li class="alert-message">{{ error }}</li>
      }
    </ul>
  </nb-alert>
}

@if (showMessages.success && messages.length && !submitted) {
  <nb-alert outline="success" role="alert">
    <p class="alert-title"><b></b></p>
    <ul class="alert-message-list">
      @for (message of messages; track message) {
        <li class="alert-message">{{ message }}</li>
      }
    </ul>
  </nb-alert>
}

<form (ngSubmit)="requestPass()" #requestPassForm="ngForm" aria-labelledby="title">
  <div class="form-control-group">
    <label for="input-username">Entrez votre nom d'utilisateur :</label>
    <input
      nbInput
      [(ngModel)]="user.username"
      #username="ngModel"
      id="input-username"
      name="username"
      placeholder="Nom d'utilisateur"
      autofocus
      fullWidth
      fieldSize="large"
      [status]="username.dirty ? (username.invalid ? 'danger' : 'success') : 'basic'"
      required
      />
      @if (username.invalid && username.touched) {
        @if (username.errors && username.errors['required']) {
          <p class="caption status-danger">
            Un nom d'utilisateur est requis !
          </p>
        }
      }
    </div>

    <div class="form-control-group">
      <label for="input-email">Entrez votre adresse mail :</label>
      <input
        nbInput
        [(ngModel)]="user.email"
        #email="ngModel"
        id="input-email"
        name="email"
        pattern=".+@.+\..+"
        placeholder="adresse mail"
        autofocus
        fullWidth
        fieldSize="large"
        [status]="email.dirty ? (email.invalid ? 'danger' : 'success') : 'basic'"
        [required]="getConfigValue('forms.validation.email.required')"
        [attr.aria-invalid]="email.invalid && email.touched ? true : null"
        />
        @if (email.invalid && email.touched) {
          @if (email.errors && email.errors['required']) {
            <p class="caption status-danger">
              Une adresse mail est requise !
            </p>
          }
          @if (email.errors && email.errors['pattern']) {
            <p class="caption status-danger">
              L'adresse mail n'est pas valide !
            </p>
          }
        }
      </div>

      <button
        nbButton
        fullWidth
        status="danger"
        size="large"
        [disabled]="submitted || !requestPassForm.valid"
        [class.btn-pulse]="submitted"
        >
        Envoyer
      </button>
    </form>

    <section class="sign-in-or-up" aria-label="Sign in or sign up">
      <p><a class="text-link" routerLink="../login">Retour à la page de connexion</a></p>
    </section>
